import { render, staticRenderFns } from "./IconLearningProgram.vue?vue&type=template&id=10a65231"
import script from "./IconLearningProgram.vue?vue&type=script&lang=js"
export * from "./IconLearningProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports